import { PayloadAction } from "@reduxjs/toolkit";
import { SaleStaffType } from "../type";
import { ApiResponse } from "types";
import api from "service/apiService";
import { call, put, takeLatest } from "redux-saga/effects";
import { translate } from "utils";
import { message } from "antd";
import {
	getListSaleStaffAsync,
	GetListSaleStaffAsyncPayload,
	setListSaleStaff,
	updateASaleStaff,
	updateASaleStaffAsync,
	UpdateSaleStaffAsyncPayload,
} from "./sale-staff.slice";
import { getListSaleStaffs, updateSaleStaffApi } from "service/apis/sale-staff";

function* getListSaleStaffSaga(
	action: PayloadAction<GetListSaleStaffAsyncPayload>,
) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { query, callback } = action.payload;
	const { response: payload, error } = yield call(async () => {
		let { skip } = query;
		const { take } = query;
		skip = skip * take;
		try {
			const response = await getListSaleStaffs({
				...query,
				skip,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (payload) {
		yield put({ type: setListSaleStaff.type, payload });
	} else {
		message.error(translate(error.message));
	}
	callback?.();
	// yield put({ type: setLoadingPage.type, payload: false });
}
function* watchGetListSaleStaff() {
	yield takeLatest(getListSaleStaffAsync, getListSaleStaffSaga);
}

function* updateSaleStaffSaga(
	action: PayloadAction<UpdateSaleStaffAsyncPayload>,
) {
	const { data: record, callback } = action.payload;
	console.log({ record });
	const { response, error } = yield call(async () => {
		try {
			await updateSaleStaffApi(record.id!, record);
			return { response: record };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: updateASaleStaff.type, payload: record });
	} else {
		message.error(translate(error.message));
	}
	callback?.();
}
function* watchUpdateASaleStaff() {
	yield takeLatest(updateASaleStaffAsync, updateSaleStaffSaga);
}
const saleStaffSaga = [watchGetListSaleStaff(), watchUpdateASaleStaff()];
export default saleStaffSaga;
